import { Search } from "lucide-react";
import React from "react";

export default function TeamMembersTable() {
  return (
    <div className="space-y-4 w-full">
      <h1 className="text-2xl sm:text-3xl text-white font-semibold">
        Team Members
      </h1>

      {/* Table Container */}
      <div className="rounded-lg bg-[linear-gradient(109.62deg,#0F131A_0%,#171D26_100%)] shadow-[0_8px_32px_0_#05070A4D] overflow-x-auto">
        {/* Header + Search */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center w-full p-4 md:p-6 border-b-[0.57px] border-b-[#1D2530] gap-3">
          <h2 className="text-xl text-white font-medium">Team Members</h2>

          <div className="relative w-full md:w-80">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search Member..."
              className="pl-10 pr-3 py-2 w-full rounded-lg bg-[#1D2530] text-gray-200 outline-none text-sm sm:text-base"
            />
          </div>
        </div>

        {/* Table */}
        <table className="min-w-full text-left text-sm sm:text-base whitespace-nowrap">
          <thead className="uppercase border-b-[0.57px] border-b-[#1D2530] text-[#9DA6AF]">
            <tr>
              <th className="px-4 sm:px-6 py-3">ID</th>
              <th className="px-4 sm:px-6 py-3">Member Name</th>
              <th className="px-4 sm:px-6 py-3">Department</th>
              <th className="px-4 sm:px-6 py-3">Next Review</th>
              <th className="px-4 sm:px-6 py-3">Performance</th>
              <th className="px-4 sm:px-6 py-3">Status</th>
            </tr>
          </thead>

          <tbody>
            {[
              {
                id: "TM001",
                name: "John Doe",
                department: "Engineering",
                review: "Jan 25, 2025",
                performance: "Excellent",
                performanceColor: "text-green-400",
                status: "Active",
              },
              {
                id: "TM002",
                name: "Sarah Lee",
                department: "Marketing",
                review: "Feb 10, 2025",
                performance: "Good",
                performanceColor: "text-yellow-400",
                status: "Active",
              },
              {
                id: "TM003",
                name: "Michael Chen",
                department: "Finance",
                review: "Mar 05, 2025",
                performance: "Average",
                performanceColor: "text-orange-400",
                status: "On Leave",
              },
              {
                id: "TM004",
                name: "Emily Davis",
                department: "HR",
                review: "Mar 22, 2025",
                performance: "Below Avg",
                performanceColor: "text-red-400",
                status: "Inactive",
              },
              {
                id: "TM005",
                name: "David Brown",
                department: "Operations",
                review: "Apr 15, 2025",
                performance: "Excellent",
                performanceColor: "text-green-400",
                status: "Active",
              },
            ].map((member) => (
              <tr
                key={member.id}
                className="border-b-[0.57px] border-b-[#1D2530] hover:bg-[#1D2530] transition-colors"
              >
                <th className="px-4 sm:px-6 py-3 text-[#9DA6AF]">
                  {member.id}
                </th>
                <td className="px-4 sm:px-6 py-3 text-white">{member.name}</td>
                <td className="px-4 sm:px-6 py-3 text-white">
                  {member.department}
                </td>
                <td className="px-4 sm:px-6 py-3 text-white">
                  {member.review}
                </td>
                <td
                  className={`px-4 sm:px-6 py-3 text-white ${member.performanceColor}`}
                >
                  {member.performance}
                </td>
                <td className="px-4 sm:px-6 py-3">
                  <span className="bg-[#FBD150] text-black px-2  rounded-xl w-max inline-block text-center">
                    {member.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
